import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TrlFormDropdown, TrlTextField } from '»components/atoms/Inputs';
import { ANGOLAN_IBAN_PREFIX } from '»utils/constants';
import {
  normalizeFieldWithoutSpaces,
  normalizeIbanWithAngolanPrefix,
} from '»utils/form';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { onboardingServices } from '../../../redux';
import { legalStatusSelector } from '../../../redux/onboarding.selectors';

export const CreateAccountStinvestFields = ({ bankInfo }) => {
  const [documentsList, setDocumentsList] = useState([]);

  const legalStatus = useSelector(legalStatusSelector);

  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    onboardingServices.getInitialDocumentsList({ legalStatus }).then((resp) => {
      const formattedDocumentsList = resp.map((document) => ({
        value: document.documentCode,
        label: document.webDescription,
      }));
      setDocumentsList(formattedDocumentsList);
    });
  }, [legalStatus]);

  return (
    <>
      <TrlFormDropdown
        name="idType"
        label={TrlFormattedMessagePlain({
          id: 'TRLT_UI-ID_DOCUMENT',
        })}
        placeholder={TrlFormattedMessagePlain({
          id: 'TRLT_UI-ID_DOCUMENT',
        })}
        options={documentsList}
        isRequired
      />

      <TrlTextField
        name="idNumber"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-DOCUMENT_NUMBER' })}
        placeholder={TrlFormattedMessagePlain({
          id: 'TRLT_UI-DOCUMENT_NUMBER',
        })}
        id="idNumber"
        isRequired
        inputProps={{
          maxLength: 20,
        }}
      />

      <TrlFormDropdown
        name="bankCode"
        label={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANKING_INSTITUTION',
        })}
        placeholder={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANKING_INSTITUTION',
        })}
        options={bankInfo}
        isRequired
        onChangeValue={(event) => {
          const bankIbanCode = bankInfo.find(
            (bank) => bank.value === event.target.value,
          ).bankIbanCode;

          if (bankIbanCode)
            setFieldValue('ibanCode', ANGOLAN_IBAN_PREFIX + bankIbanCode);
        }}
      />

      <TrlTextField
        name="ibanCode"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN' })}
        placeholder={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN' })}
        id="ibanCode"
        isRequired
        additionalFunc={normalizeIbanWithAngolanPrefix({
          fieldName: 'ibanCode',
          setFieldValue,
        })}
      />

      <TrlTextField
        name="ibanCode2"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN_USD' })}
        placeholder={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN_USD' })}
        id="ibanCode2"
        additionalFunc={normalizeFieldWithoutSpaces({
          fieldName: 'ibanCode2',
          setFieldValue,
        })}
      />

      <TrlTextField
        name="email1"
        type="email"
        autoComplete="email"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-EMAIL' })}
        placeholder={TrlFormattedMessagePlain({ id: 'TRLT_UI-EMAIL' })}
        id="email1"
        isRequired
      />
    </>
  );
};

CreateAccountStinvestFields.propTypes = {
  bankInfo: PropTypes.array.isRequired,
};
